import { memo, useState } from "react";
import Form from "../../components/Form.js";
import { Box, Typography, Button } from "@mui/material"
import Spinner from "../../components/Spinner.js";
import useSelectStyles from "../../components/styles/Select.js";
import SelectOwnerForm from "../../components/forms/OwnerSelect.js"
import { useSnackbar } from "../../utils/index.js"
import { getAnimalsByStatus, getAnimalRelatives } from "../../api/index.js";
import AnimalRelativesPdf from "../../components/info-pdfs/AnimalRelatives.js"

const FamilyRelatives = () => {
    const [selectedOwner, setSelectedOwner] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedAnimals, setFetchedAnimals] = useState([]);
    const [animalsDropdownValues, setAnimalsDropdownValues] = useState([]);
    const [step, setStep] = useState(1);
    const [selectedAnimal, setSelectedAnimal] = useState(null);
    const [relatives, setRelatives] = useState([]);


    const classes = useSelectStyles();
    const { error } = useSnackbar();

    const fetchAnimals = async (selOwner, status) => {
        setIsLoading(true);
        try {
            const { success: scs, animals, message } = await getAnimalsByStatus(selOwner, status);
            if (scs) {
                setStep(2)
                setFetchedAnimals(animals);
                setAnimalsDropdownValues(
                    animals.map((animal) => ({
                        value: animal?.registrationCode,
                        text: animal?.registrationCode,
                    }))
                )
            } else {
                error(message);
            }
        } catch (err) {
            error(err)
        }
        setIsLoading(false);
    }


    const selectAnimalFormContent = [
        {
            customType: "dropdown",
            id: "animal",
            items: animalsDropdownValues,
            placeholder: "Κωδικός Ζώου",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή"
        },
    ];

    const handleSelectAnimal = async (values) => {
        setIsLoading(true);
        const selectedAnimalObj = fetchedAnimals.find((animal) => animal?.registrationCode === values?.animal);
        setSelectedAnimal(selectedAnimalObj)
        try {
            const { success: scs, data } = await getAnimalRelatives(selectedAnimalObj?._id);
            if (scs) {
                setRelatives(data);
                setStep(3);
            }
        } catch (err) {
            error(err)
        }
        setIsLoading(false);
    }

    return (
        <>
            <Spinner open={isLoading} />
            {step === 1 && (
                <SelectOwnerForm
                    setSelectedOwner={setSelectedOwner}
                    title={"Επιλέξτε Εκτροφή"}
                    method={fetchAnimals}
                    screenCase={"AnimalRelatives"}
                />
            )}
            {step === 2 && (
                <>
                    <Box className={classes.outerBox}>
                        <Box container flexDirection="column" className={classes.innerBox}>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                Επιλέξτε τον ζώο του οποίου τους συγγενείς θέλετε να δείτε
                            </Typography>
                            <Form content={selectAnimalFormContent} onSubmit={handleSelectAnimal} />
                            <Button
                                onClick={() => setStep(1)}
                                sx={{
                                    marginTop: "1rem",
                                    padding: "0.5rem 1rem",
                                    backgroundColor: "third",
                                    color: "secondary.main",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    variant: "h5",
                                }}
                            >
                                Πίσω
                            </Button>
                        </Box>
                    </Box>
                </>
            )}
            {step === 3 && (
                <AnimalRelativesPdf
                    fetchedData={relatives}
                    selectedAnimal={selectedAnimal}
                    selectedOwner={selectedOwner}
                />
            )}
        </>
    )
}

export default memo(FamilyRelatives)